export default "__VITE_ASSET__CCXfcq2B__"